const SKELETON_CARD_COUNT = 4;

export function ImageryOptionsSkeleton(): React.ReactElement {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4" data-testid="imagery-options-skeleton">
      {Array.from({ length: SKELETON_CARD_COUNT }, (_, index) => index).map((index) => (
        <div key={`imagery-skeleton-${index}`} className="rounded-md border overflow-hidden">
          <div className="aspect-square bg-muted animate-pulse" />
          <div className="p-2 space-y-2">
            <div className="h-3 w-3/4 rounded bg-muted animate-pulse" />
            <div className="h-3 w-full rounded bg-muted animate-pulse" />
            <div className="h-6 w-full rounded bg-muted animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  );
}
